import React, { useEffect, useState } from "react";
import {
  Badge,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import { COMERCIAL_OPTIONS, OPERACIONES_OPTIONS } from "./cofidisAgentConfig";

export const normalizeFormSimpleFilters = (filters = {}) => ({
  operacionesAgent: filters.operacionesAgent || "",
  comercialAgent: filters.comercialAgent || "",
  dateFrom: filters.dateFrom || "",
  dateTo: filters.dateTo || "",
});

const localDateBoundaryIso = (date, extraDays = 0) => {
  if (!date) return "";
  const [year, month, day] = date.split("-").map(Number);
  return new Date(year, month - 1, day + extraDays).toISOString();
};

export const formSimpleDateBounds = (filters = {}) => ({
  from: localDateBoundaryIso(filters.dateFrom),
  // El límite superior es exclusivo para incluir el día «Hasta» completo.
  toExclusive: localDateBoundaryIso(filters.dateTo, 1),
});

export const FormSimpleFilter = ({ filters, setFilters }) => {
  const [open, setOpen] = useState(false);
  const [localFilters, setLocalFilters] = useState(normalizeFormSimpleFilters(filters));

  useEffect(() => {
    setLocalFilters(normalizeFormSimpleFilters(filters));
  }, [filters]);

  const activeCount = Object.values(normalizeFormSimpleFilters(filters)).filter(Boolean).length;

  const handleChange = (field) => (event) => {
    setLocalFilters((previous) => ({ ...previous, [field]: event.target.value }));
  };

  const close = () => {
    setLocalFilters(normalizeFormSimpleFilters(filters));
    setOpen(false);
  };

  const clear = () => {
    const empty = normalizeFormSimpleFilters();
    setLocalFilters(empty);
    setFilters(empty);
    setOpen(false);
  };

  const apply = () => {
    setFilters(normalizeFormSimpleFilters(localFilters));
    setOpen(false);
  };

  return (
    <>
      <Badge badgeContent={activeCount || 0} color="primary">
        <Button
          id="form-simple-filter-button"
          onClick={() => setOpen(true)}
          startIcon={<FilterListIcon />}
          variant="outlined"
          size="small"
        >
          Filtrar
        </Button>
      </Badge>
      <Dialog open={open} onClose={close} maxWidth="sm" fullWidth>
        <DialogTitle>Filtrar formularios</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3, pt: 1 }}>
            <TextField
              label="Operaciones"
              value={localFilters.operacionesAgent}
              onChange={handleChange("operacionesAgent")}
              size="small"
              select
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
              fullWidth
            >
              <option value="">Todos</option>
              {OPERACIONES_OPTIONS.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </TextField>
            <TextField
              label="Comercial"
              value={localFilters.comercialAgent}
              onChange={handleChange("comercialAgent")}
              size="small"
              select
              SelectProps={{ native: true }}
              InputLabelProps={{ shrink: true }}
              fullWidth
            >
              <option value="">Todos</option>
              {COMERCIAL_OPTIONS.map((option) => (
                <option key={option} value={option}>{option}</option>
              ))}
            </TextField>
            <Box sx={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 2 }}>
              <TextField
                label="Desde"
                type="date"
                value={localFilters.dateFrom}
                onChange={handleChange("dateFrom")}
                size="small"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
              <TextField
                label="Hasta"
                type="date"
                value={localFilters.dateTo}
                onChange={handleChange("dateTo")}
                size="small"
                InputLabelProps={{ shrink: true }}
                fullWidth
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={clear} size="small">Limpiar</Button>
          <Button onClick={apply} variant="contained" size="small">Aplicar</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
